import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { SKIP_ERROR_TOAST } from './http/http-context-tokens';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly _http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    // A scope file (lang contains "/") belongs to a panel or page that shows its own load error; the global toast would repeat it.
    const context = lang.includes('/') ? new HttpContext().set(SKIP_ERROR_TOAST, true) : undefined;
    return this._http.get<Translation>(`/assets/i18n/${lang}.json`, { context });
  }
}
